export default __webpack_public_path__ + "static/media/ripple-1.b8d166f1.webp";